const avnFont = {
  "header-font": ["faktum", "DM Serif Display", "sans-serif"],
  "sub-section-header-font": ["faktum", "DM Serif Display", "sans-serif"],
  "proxima-nova": ["proxima-nova", "Helvetica", "Arial", "sans-serif"],
  ciutadella: ["Ciutadella Rounded", "sans-serif"],
  "body-font": ["faktum", "proxima-nova", "Helvetica", "Arial", "sans-serif"],
  opensans: ["Open Sans", "sans-serif"],
  "semibold-font": ["faktum", "proxima-nova", "sans-serif"],
  "source-sans-pro-regular": ["source-sans-pro-regular", "sans-serif"],
  helvetica: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"],
};

export default avnFont;
